import OrderTotal from "./OrderTotal"

export default OrderTotal